const callOptionalFunction = (optionalFunction?: () => void) => {
    if (optionalFunction) {
        optionalFunction();
    }
}

export default callOptionalFunction;